export default __webpack_public_path__ + "static/media/recipient_signature.d16a6d44.jpeg";